import React from 'react';
import { View, Text } from 'react-native';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CustomSelect from 'root/libs/exaforte/react/form/CustomSelect';
import { customSelectStyles } from 'root/globals/Form';

import {
    faChevronLeft,
    faChevronRight
} from '@fortawesome/pro-light-svg-icons';

library.add(faChevronLeft, faChevronRight);

import defaults from 'root/globals/Defaults.less';
import pagination from './Pagination.less';

const styles = {...defaults, ...pagination};

/*
 * verplichte props:
 *      (int)currentPage
 *      (int)totalAmount
 *      (int)pageLimit
 *
 * optionele props:
 *      (func)onPageSelect(int page_number)
 *      (bool)hideArrows
 */
 
const CustomSmallSelectStyles = {...customSelectStyles, ...{
    control: styles => ({
        ...styles,
        minHeight: 'auto',
        fontSize: 13,
    }),
    indicatorsContainer: styles => ({
        ...styles,
        '& > div': {
            padding: 0,
            marginRight: 4,
        }
    }),
    option: styles => ({
        ...styles,
        fontSize: 13,
    })
}};

export default class Pagination extends React.Component {
    static getPaginationSettings(settings) {
        settings            = {split_limit: 8, ...settings};
        let pages           = Math.ceil(settings.record_amount / settings.limit) - 1;
        let displayed_pages = pages;
        let start_page      = 1;
        let end_page        = pages;
        
        if(pages < 1)
            return null;
            
        if(displayed_pages > settings.split_limit)
        {
            displayed_pages = settings.split_limit;
            
            if(settings.page > (settings.split_limit/2))
                start_page = settings.page - (settings.split_limit/2);
            
            end_page = (start_page+displayed_pages);
            
            if(end_page > pages)
            {
                start_page  = pages - settings.split_limit;
                end_page    = pages;
            }
        }
        
        return {pages: pages, start_page: start_page, end_page: end_page};
    }
    
    render() {
        let settings = Pagination.getPaginationSettings({record_amount: this.props.totalAmount, limit: this.props.pageLimit, page: this.props.currentPage});
        
        if(settings == null)
            return null;
        
        let { pages, start_page, end_page } = settings;
        let page_items                      = [];

        for(let i = start_page;i < end_page;i++)
            page_items.push(<TouchableArea key={'p-' + i} className={[styles['px-0-5'], 'd-flex', styles['background-color-white'], styles['f-1-5'], styles['pagination-i'], ...(this.props.currentPage == i ? [styles['pagination-i-select']] : [])]} {...((typeof this.props.onPageSelect == 'function' && this.props.currentPage != i) && {onPress: () => {this.props.onPageSelect(i);}})}>{parseInt(i)+1}</TouchableArea>);

        return <View className={[styles[''], styles['pagination-container'], 'd-flex flex-column flex-md-row align-items-center align-items-md-start']}>
            {!_.is_empty(this.props.selectPageAmount) && <View className={['mr-3', styles['page-amount-selector']]}>
                <CustomSelect styles={CustomSmallSelectStyles} options={[{label: '25 per pagina', value: 25},{label: '50 per pagina', value: 50},{label: '100 per pagina', value: 100},{label: '200 per pagina', value: 200},{label: '400 per pagina', value: 400}]} onChangeText={this.props.selectPageAmount} value={this.props.pageLimit} mandatory={true}/>
            </View>}
            <View className={['d-flex flex-row mt-2 mt-md-0']}>
                {!this.props.hideArrows && (
                    <View className={['d-flex']}>
                        <TouchableArea className={[styles['background-color-white'], 'd-flex justify-content-center align-items-center mr-2', styles['f-1-5'], styles['pagination-arrow'], ...(this.props.currentPage == 0 ? [styles['pagination-arrow-disabled']] : [])]} {...(this.props.currentPage > 0 && typeof this.props.onPageSelect == 'function' ? {onPress: () => {this.props.onPageSelect(parseInt(this.props.currentPage) - 1);}} : {})}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </TouchableArea>
                    </View>
                )}
                <TouchableArea className={[styles['px-0-5'], styles['background-color-white'], styles['f-1-5'], styles['pagination-i'], ...(this.props.currentPage == 0 ? [styles['pagination-i-select']] : [])]} {...(typeof this.props.onPageSelect == 'function' && this.props.currentPage != 0 ? {onPress: () => {this.props.onPageSelect(0);}} : {})}>1</TouchableArea>
                {start_page != 1 && <Text className={[styles['px-0-5'], styles['seperator']]}>...</Text>}
                {page_items}
                {end_page != pages && <Text className={[styles['px-0-5'], styles['seperator']]}>...</Text>}
                <TouchableArea className={[styles['px-0-5'], styles['background-color-white'], styles['f-1-5'], styles['pagination-i'], ...(this.props.currentPage == pages ? [styles['pagination-i-select']] : [])]} {...(typeof this.props.onPageSelect == 'function' && this.props.currentPage != pages ? {onPress: () => {this.props.onPageSelect(pages);}} : {})}>{pages + 1}</TouchableArea>
                {!this.props.hideArrows && (
                    <View className={['d-flex']}>
                        <TouchableArea className={[styles['background-color-white'], 'd-flex justify-content-center align-items-center ml-2', styles['f-1-5'], styles['pagination-arrow'], ...(this.props.currentPage == pages ? [styles['pagination-arrow-disabled']] : [])]} {...(this.props.currentPage < pages && typeof this.props.onPageSelect == 'function' ? {onPress: () => {this.props.onPageSelect(parseInt(this.props.currentPage) + 1);}} : {})}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </TouchableArea>
                    </View>
                )}
            </View>
        </View>
    }
}